module.exports = __webpack_public_path__ + "dist/fiona_xie.2bf91305.png";